import React from "react";
import { useAverageBasedCalculator } from "../../../hooks/useAverageBasedCalculator";
import { useSelectedInstrument, useCompanySettings } from "../../../../hooks/useCompanySettings";
import AverageBasedCalculatorForm from "../../AverageBasedCalculatorForm/AverageBasedCalculatorForm";
import AverageBasedCalculatorResults from "../../AverageBasedCalculatorResults/AverageBasedCalculatorResults";

const QuadrataAverageBasedCalculator = ({ onClose }) => {
    const { formState, results, handleSubmit, loading, lastPrice } = useAverageBasedCalculator();
    const [, { formatNumber }] = useSelectedInstrument();
    const companySettings = useCompanySettings();

    const currency = formState.getFieldValue("currency") || results?.currency || "";

    return (
        <div className="average-based-calculator average-based-calculator--quadrata">
            <div className="average-based-calculator__content">
                <AverageBasedCalculatorForm
                    formState={formState}
                    onSubmit={handleSubmit}
                    loading={loading}
                    currencyCode={companySettings.currencyCode}
                    companySettings={companySettings}
                />

                {results && (
                    <AverageBasedCalculatorResults
                        results={results}
                        formatNumber={formatNumber}
                        currency={currency}
                    />
                )}
            </div>
        </div>
    );
};

export default QuadrataAverageBasedCalculator;

